import React from "react";
import css from "./Footer.module.css";
import Logo from "../../assets/logo.png";
import { FaFacebook, FaInstagram } from "react-icons/fa";

import {
    InboxIcon,
    PhoneIcon,
    MapPinIcon,
    UserIcon,
    LinkIcon,
} from "@heroicons/react/24/outline";

const Footer = () => {
    return (
        <div className={css.cFooterWrapper}>
            <hr className={css.divider} />

            <div className={css.cFooter}>

                {/* Logo Section */}
                <div className={css.clogo}>
                    <img src={Logo} alt="logo" />
                    <span>E-Bazaar</span>
                    <p>Your one stop shop for quality products.</p>
                </div>

                {/* Contact Section */}
                <div className={css.block}>
                    <span className={css.title}>Contact Us</span>

                    <div className={css.pngLine}>
                        <MapPinIcon className={css.icon} />
                        <span>Silk Plaza Abbottabad, Pakistan</span>
                    </div>

                    <div className={css.pngLine}>
                        <PhoneIcon className={css.icon} />
                        <span>+92 300 xxxxxxx</span>
                    </div>

                    <div className={css.pngLine}>
                        <InboxIcon className={css.icon} />
                        <span>support@ebazaar.com</span>
                    </div>
                </div>

                {/* Quick Links */}
                <div className={css.block}>
                    <span className={css.title}>Follow Us</span>

                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.pngLine}
                    >
                        <FaFacebook className={css.icon} />
                        <span>Facebook</span>
                    </a>

                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.pngLine}
                    >
                        <FaInstagram className={css.icon} />
                        <span>Instagram</span>
                    </a>

                </div>

                {/* Account */}
                <div className={css.block}>
                    <span className={css.title}>Account</span>

                    <div className={css.pngLine}>
                        <UserIcon className={css.icon} />
                        <span>My Account</span>
                    </div>

                    <div className={css.pngLine}>
                        <UserIcon className={css.icon} />
                        <span>Orders</span>
                    </div>

                    <div className={css.pngLine}>
                        <UserIcon className={css.icon} />
                        <span>Wishlist</span>
                    </div>
                </div>
            </div>

            <div className={css.bottom}>
                © 2026 E-Bazaar. All Rights Reserved.
            </div>
        </div>
    );
};

export default Footer;